module.exports = __webpack_public_path__ + "img/recent-work-03.4f309396.jpg";